import type { CheckRunRerunSummaryOptions } from './types'

import { AuditLogAction } from '../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../domain/audit-log-resource-type.enum'

export const AUDIT_LOG_ACTION_NAMES_MAPPER: Record<AuditLogAction, string> = {
  [AuditLogAction.Read]: 'Read',
  [AuditLogAction.Create]: 'Create',
  [AuditLogAction.Update]: 'Update',
  [AuditLogAction.Delete]: 'Delete',
  [AuditLogAction.Rebuild]: 'Rebuild',
  [AuditLogAction.Rerun]: 'Rerun',
  [AuditLogAction.Dropoff]: 'Dropoff'
}

export const AUDIT_LOG_ACTIONS = Object.entries(AUDIT_LOG_ACTION_NAMES_MAPPER).map(
  ([key, value]) => ({
    value: key,
    text: value
  })
)

export const AUDIT_LOG_ACTION_CLASSNAMES_MAPPER: Record<AuditLogAction, string> = {
  [AuditLogAction.Create]: 'text-[#15803D] bg-[#ECFDF5] border-[#22C55E]',
  [AuditLogAction.Read]: 'text-[#4B5563] bg-[#F3F4F6] border-[#9CA3AF]',
  [AuditLogAction.Update]: 'text-[#1D4ED8] bg-[#EFF6FF] border-[#3B82F6]',
  // TODO: zabelin wait for classes
  [AuditLogAction.Delete]: '',
  [AuditLogAction.Rebuild]: '',
  [AuditLogAction.Rerun]: 'text-[#4338CA] bg-[#EEF2FF] border-[#6366F1]',
  [AuditLogAction.Dropoff]: 'text-[#B45309] bg-[#FEF3C7] border-[#F59E0B]'
}

export const AUDIT_LOG_RESOURCE_TYPE_NAMES_MAPPER: Record<AuditLogResourceType, string> = {
  [AuditLogResourceType.CheckRun]: 'Check Run',
  [AuditLogResourceType.CheckRunList]: 'Check Run List',
  [AuditLogResourceType.File]: 'File',
  [AuditLogResourceType.CoverageCategoryOnGroup]: 'Coverage Category On Group',
  [AuditLogResourceType.CRNotificationRecipient]: 'CR Notification Recipient',
  [AuditLogResourceType.CRReportOnGroup]: 'CR Report On Group',
  [AuditLogResourceType.Group]: 'Group',
  [AuditLogResourceType.GroupSchedule]: 'Group Schedule',
  [AuditLogResourceType.Holiday]: 'Holiday',
  [AuditLogResourceType.HolidayOverride]: 'Holiday Override',
  [AuditLogResourceType.JWTToken]: 'JWT Token',
  [AuditLogResourceType.NotificationRecipient]: 'Notification Recipient',
  [AuditLogResourceType.OneTimeCode]: 'One Time Code',
  [AuditLogResourceType.User]: 'User'
}

export const AUDIT_LOG_RESOURCE_TYPES = Object.entries(AUDIT_LOG_RESOURCE_TYPE_NAMES_MAPPER).map(
  ([key, value]) => ({
    value: key,
    text: value
  })
)

export const AUDIT_LOG_CHECK_RUN_RERUN_SUMMARY_MAPPER: Record<CheckRunRerunSummaryOptions, string> =
  {
    resetTotalsChecked: 'Reset totals',
    rebuildCheckRegisterReports: 'Rebuild register reports',
    dropOffToLin: 'Drop-off to LIN',
    emailNotification: 'Email notification'
  }

export const WEEK_DAY_NAMES = [
  null,
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  null
] as const
export const WEEK_START_DAY: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0

export const GROUP_UPDATE_EXCLUDED_PATHS = ['updated_at', 'id']

export const GROUP_UPDATE_FIELD_NAMES_MAP: Record<string, string> = {
  effective_date: 'Effective Date',
  termination_date: 'Termination Date',
  funding: 'Funding',
  account_executive: 'Account Executive',
  sales_executive: 'Sales Executive',
  notes: 'Notes',
  account_manager: 'Account Manager',
  release_type: 'Release Type',
  ignore_stop_loss: 'Stop Loss',
  renewal_date: 'Renewal Date',
  run_out_date: 'Run Out Date',
  rx_company: 'RX Company',
  group_contact: 'Group Contact',
  request_for_funding: 'RFF',
  is_on_hold: 'On Hold',
  is_expired: 'Expired',
  release: 'Release',
  reports: 'Check Register Reports',
  coverage_categories: 'Coverage Categories',
  notification_recipients: 'Email Management',
  schedule: 'Schedule',
  network: 'Network',
  network_account_number: 'Network Account Number',
  network_routing_number: 'Network Routing Number',
  network_banking_id: 'Network Banking ID',
  network_originator_id: 'Network Originator ID',
  activation_date: 'Activation Date',
  checks_only: 'Checks Only',
  level_funded: 'Level Funded',
  full_amount: 'Full Amount',
  zelis_eligible: 'Zelis Eligible',
  status: 'Status',
  push_type: 'Push Type',
  group_account_number: 'Group Account Number',
  group_routing_number: 'Group Routing Number',
  group_banking_id: 'Group Banking ID',
  group_originator_id: 'Group Originator ID',
  claims_account_number: 'Claims Account Number',
  claims_routing_number: 'Claims Routing Number',
  claims_banking_id: 'Claims Banking ID',
  claims_originator_id: 'Claims Originator ID',
  funding_type: 'Funding Type'
}
